/* eslint-disable */
const state = {
    color: null,
    loading: null,
  };
  
  const actions = {
    setColor({ commit }, color) {
      commit("create", color);
    },
    start({ commit }) {
      commit("start");
    },
    stop({ commit }) {
      commit("stop");
    },
    clear({ commit }) {
      commit("clear");
    },
  };
  
  const mutations = {
    create(state, color) {
      state.color = color;
    },
    start(state) {
      state.loading = true;
    },
    stop(state) {
      state.loading = false;
    },
    clear(state) {
      state.color = null;
      state.loading = null;
    },
  };
  
  export const loader = {
    namespaced: true,
    state,
    actions,
    mutations,
  };
  